import { call, select, put, takeLatest } from 'redux-saga/effects';

import API from 'services/api';

import { receiveGroup } from 'store/session/actions';
import { getGroupId } from 'store/session/selectors';

import { types, updateLeadTimeUnit } from './actions';

export default function* root() {
  yield takeLatest(
    types.UPDATE_LEAD_TIME_UNIT_REQUEST,
    watchUpdateLeadTimeUnit,
  );
}

function* watchUpdateLeadTimeUnit(action) {
  try {
    const { leadTimeUnit } = action.payload;
    const groupId = yield select(getGroupId);
    yield call(API.groups.updateUserGroup, groupId, { leadTimeUnit });
    yield put(receiveGroup({ leadTimeUnit }));
    yield put(updateLeadTimeUnit.success());
  } catch (e) {
    yield put(updateLeadTimeUnit.error(e));
  }
}
